// extracted by mini-css-extract-plugin
export default {"container":"ProjectCard_container__KPNV9","buttons":"ProjectCard_buttons__+J--p"};